/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcRouteV1FixMessageState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ROUTE_V1_FIX_MESSAGE_STATE_ENTITY_NAME = 'exc.route.v1.FixMessage';
export const excRouteV1FixMessageStateEntity = new schema.Entity<ExcRouteV1FixMessageState>(EXC_ROUTE_V1_FIX_MESSAGE_STATE_ENTITY_NAME, {}, { idAttribute: 'fixMessageId' });

